module.exports = __webpack_public_path__ + "static/assets/8d2335f9bd6933b4a990b795fdef1839.png";